import { render, staticRenderFns } from "./yetkilendirmeler.vue?vue&type=template&id=c2bd5f0a&scoped=true"
import script from "./yetkilendirmeler.vue?vue&type=script&lang=js"
export * from "./yetkilendirmeler.vue?vue&type=script&lang=js"
import style0 from "./yetkilendirmeler.vue?vue&type=style&index=0&id=c2bd5f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2bd5f0a",
  null
  
)

export default component.exports